import { Component, Vue, Prop } from 'vue-property-decorator';
import { OnboardingRegistration } from '@/common/models';

@Component({
  components: {
  },
})
export default class RegistrationDetailsCustomer extends Vue {
  @Prop({required: true}) onboardingRegistration!: OnboardingRegistration;
}
